import { Block } from "modules/Block";

export class FeatureComparisonBlock extends Block<typeof FeatureComparisonBlock> {

    static readonly className: string = "js-feature-comparison-block";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);
        this.initPrintButton();
    }

    private initPrintButton(): void {
        const printButton = this.rootElement.querySelector('[data-action="print-table"]');
        if (printButton) {
            printButton.addEventListener("click", () => {
                document.body.classList.add("print-feature-comparison");
                window.print();
            });
            window.onafterprint = () => {
                document.body.classList.remove("print-feature-comparison");
            };
        }
    }
}
